module.exports = __webpack_public_path__ + "static/apple-touch-icon-180x180-dcd8652a15d944489c8d719304cce83b.png";